import { render, staticRenderFns } from "./m-orm-deactivate-dialog.vue?vue&type=template&id=f625da16&lang=pug&"
import script from "./m-orm-deactivate-dialog.vue?vue&type=script&lang=js&"
export * from "./m-orm-deactivate-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports